import css from 'styled-jsx/css';

export default css`
  .moduloOpiniones {
    display: flex;
    flex-direction: column;
    margin-top: 35px;
    margin-bottom: 60px;
    .sectionOpinion {
      display: flex;
      flex-direction: column;
      padding: 30px;
      padding-bottom: 60px;
      gap: 1rem;
      width: 392px !important;
      height: 280px;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 16px;
      position: relative;
    }
    .sectionIcons {
      display: flex;
      gap: 0.3rem;
    }
    :global(.icon) {
      color: #f6d13a;
    }
    :global(.title) {
      margin: 15px 0;
    }
    :global(.linkComment) {
      position: absolute;
      bottom: 25px;
      left: 30px;
    }
    .sectionNameUser {
      display: flex;
      justify-content: space-between;
    }
    :global(.slick-slide > div) {
      height: 100%;
    }
    :global(.slick-dots li.slick-active button:before) {
      color: #019df4;
    }
  }
  @media screen and (max-width: 768px) {
    .moduloOpiniones {
      .sectionOpinion {
        min-width: 20rem;
        width: 100% !important;
      }
    }
  }
`;
